"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "work-schedules-table"
  }, [_c("b-table", {
    attrs: {
      data: _vm.processedWorks,
      loading: _vm.isLoading,
      striped: true,
      hoverable: true,
      "mobile-cards": true
    },
    on: {
      "update:loading": function updateLoading($event) {
        _vm.isLoading = $event;
      }
    }
  }, [_c("b-table-column", {
    attrs: {
      field: "title",
      label: "Escala"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.title) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "start",
      label: "Início do turno"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.start) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "end",
      label: "Término do turno"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.end) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "weekdaysLabel",
      label: "Dias da semana"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.weekdaysLabel) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "breaks",
      label: "Intervalos"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("ul", {
          staticClass: "breaks-list"
        }, _vm._l(props.row.breaksFmt, function (item, idx) {
          return _c("li", {
            key: idx
          }, [_vm._v("\n          " + _vm._s(item) + "\n        ")]);
        }), 0)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;